































































































































import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import KelasAutoComplete from "@/components/KelasAutoComplete.vue";
import StatusAutoComplete from "@/components/StatusAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { storeReferensi } from "@/store/modules/referensi";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    UnitAutoComplete,
    KelasAutoComplete,
    StatusAutoComplete
  }
})
export default class ModalEditKamar extends Vue {
  @Prop() readonly value!: boolean;
  // @Prop() item!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*Alasan harus diisi"];
  msg = "";
  unit = {};
  // kelas = this.item["kelas"];
  // status = this.item["status"];
  no = null;
  checkGabung = false;
  gabung = "0";
  // it = {};

  mounted() {
    // this.it = this.item;
    // this.kelas = this.item["kelas"];
    // this.status = this.item["status"];
  }

  get item() {
    return storeReferensi.tempStatus;
  }

  get akses() {
    return storeBed.akses;
  }

  @Watch("item")
  valItem(val) {
    if (val["gabung"] == "1") {
      this.checkGabung = true;
    } else {
      this.checkGabung = false;
    }
  }

  simpan() {
    if (this.checkGabung == true) {
      this.gabung = "1";
    } else {
      this.gabung = "0";
    }
    // console.log(this.item["kelas"]);
    const dt = DataBed.editBed(
      this.item["id"],
      this.item["kamar"],
      this.item["kelas"].id,
      this.item["status"].id,
      this.user["pegawai_id"],
      this.gabung,
      this.item["catatan_bed"]
    );
    dt.then(dt => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil Mengubah Kamar");
        storeBed.actBedByUnit(this.item["unit"].id);
        this.close();
      }
    });
  }
  setUnit(val) {
    this.unit = val;
  }
  setKelas(val) {
    this.item["kelas"] = val;
  }
  setStatus(val) {
    this.item["status"] = val;
  }

  close() {
    this.unit = {};
    this.no = null;
    storeBed.actBedByUnit(this.item["unit"].id);
    this.show = false;
    // alert("mm");
  }

  message() {
    return this.msg;
  }

  get user() {
    return userModule.user;
  }

  get show() {
    // alert("ss");
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
